import receiptReducer from './receiptReducer';
export default receiptReducer;